<template>
  <v-dialog v-model="isDialogActive" max-width="700" z-index="100001">
    <template v-slot:default="{ isActive }">
      <v-card :class="[props.noPadding ? 'pa-0' : 'pa-6', 'ga-3']" rounded="xl" :color="props.color">
        <!-- Close Icon -->
        <span class="d-flex flex-column align-center mt-4 mr-4 position-absolute right-0" style="z-index: 100002;">
          <v-icon
          class="align-self-md-end"
          style="opacity: 1; margin-bottom: -10px"
          :color="props.closeIcon ? 'white' : 'primary'"
          size="22px"
          @click="handleClose"
          >
          mdi-close
        </v-icon>
        
      </span>
      <!-- Modal Header -->
      <v-card v-if="title || description" class="d-flex justify-space-between flex-row ma-0 pa-0" flat variant="text" style="min-height: fit-content;">
        <span class="d-flex align-baseline flex-column ga-0 ma-0 pa-0">
          <!-- <v-icon class="ma-0 mr-2" style="opacity: 1" color="primary" size="18px">mdi-information-slab-circle</v-icon> -->
          <h1 class="ma-0 pa-0 ps-1 text-start modal_h1_title">
            {{ title }}
          </h1>
          <p v-if="description" class="ma-0 py-0" style="font-size: 16px; padding-left: 1px; font-style: italic; color: rgb(var(--v-theme-primary)) !important;">
            {{ description }}
          </p>
        </span>
      </v-card>
      <div class="ma-0 pa-0">
        <v-card class="ma-0 pa-0" variant="text" rounded="lg">
          <!-- Dynamic Component Loader -->
          <component :is="pageComponent" v-bind="pageComponentProps" @close="handleClose" @action="handleAction" />
        </v-card>
      </div>
    </v-card>
  </template>
</v-dialog>
</template>

<script lang="ts" setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import { useModalStore } from '@/store/modalStore';

// Pinia store
const modalStore = useModalStore();

// Props (for existing click functionality)
const props = defineProps({
  title: String,
  description: String,
  pageComponent: Object,
  isVisible: Boolean,
  pageComponentProps: Object,
  boxid: Number,
  color: {
    type: String,
    default: 'white'
  },
  closeIcon: {
    type: Boolean,
    default: false
  },
  noPadding: Boolean,
});

// Emit events
const emit = defineEmits(['update:modelValue', 'action']);

// Reactive state for existing click functionality
const isDialogActive = ref(props.isVisible);

// Watch for visibility prop changes (existing functionality)
watch(
() => props.isVisible,
(newVal) => {
  isDialogActive.value = newVal;
},
{ immediate: true } // ✅ Ensure it runs immediately
);

// Watch for store-based modal trigger
watch(
() => modalStore.isVisible,
(newVal) => {
  // console.groupCollapsed('[ModalPopup] Visibility Change');
  // console.log(`🔄 New Visibility: ${newVal ? 'OPEN' : 'CLOSED'}`);
  // console.groupEnd();
  
  isDialogActive.value = newVal;
}
);

watch(
() => props.noPadding,
(val) => {
  console.groupCollapsed('[ModalPopup] Padding State');
  console.log('🔧 noPadding prop:', val);
  console.log('➡️ Applied class:', val ? 'pa-0' : 'pa-6');
  console.groupEnd();
},
{ immediate: true }
);


// Handle close action (works for both store and click-triggered modal)
const handleClose = () => {
  isDialogActive.value = false;
  modalStore.closeModal(); // Close via store if needed
  emit('update:modelValue', false);
};

// Handle actions emitted by the dynamic component
const handleAction = (actionData: any) => {
  emit('action', actionData); // Pass action data to the parent
};
</script>

<style lang="scss">
// H1 title style for the modal
.modal_h1_title {
  text-transform: uppercase;
  font-weight: 500;
  font-style: italic;
  font-family: $mongoose-font;
  font-size: 2rem;
  color: rgb(var(--v-theme-primary));
  line-height: 32px;
}

</style>
